const customContainerCommonStyles = (FOUNDATIONS) => ({
    position: 'absolute',
    right: '-4px',
    bottom: '-4px',
    display: 'flex',
    align_items: 'center',
    justify_content: 'center',
    background_color: FOUNDATIONS.color_accent_selected_bg_50,
    border_radius: FOUNDATIONS.radius_1000,
    border: `${FOUNDATIONS.border_75} solid ${FOUNDATIONS.color_neutral_border_static_50}`,
});
export const commonStyles = (FOUNDATIONS) => ({
    parentContainer: {
        position: 'relative',
    },
    customContentContainer: {
        ...customContainerCommonStyles(FOUNDATIONS),
        disabled: {
            ...customContainerCommonStyles(FOUNDATIONS),
            background_color: FOUNDATIONS.color_accent_disabled_bg_300,
        },
    },
});
export const commonStylesExtraExtraSmall = (FOUNDATIONS) => ({
    ...commonStyles(FOUNDATIONS),
    container: {
        border_radius: FOUNDATIONS.radius_125,
        padding: FOUNDATIONS.spacing_125,
        background_color: FOUNDATIONS.color_comp_resources_iconhighlighted_bg,
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        selected: {
            border_color: FOUNDATIONS.color_accent_selected_border_50,
        },
    },
    icon: {
        width: FOUNDATIONS.size_150,
        height: FOUNDATIONS.size_150,
        color: FOUNDATIONS.color_neutral_icon_50,
        disabled: {
            width: FOUNDATIONS.size_150,
            height: FOUNDATIONS.size_150,
            color: FOUNDATIONS.color_accent_disabled_icon_100,
        },
    },
});
export const commonStylesExtraSmall = (FOUNDATIONS) => ({
    ...commonStyles(FOUNDATIONS),
    container: {
        border_radius: FOUNDATIONS.radius_200,
        padding: FOUNDATIONS.spacing_150,
        background_color: FOUNDATIONS.color_comp_resources_iconhighlighted_bg,
        width: FOUNDATIONS.size_400,
        height: FOUNDATIONS.size_400,
        selected: {
            border_color: FOUNDATIONS.color_accent_selected_border_50,
        },
    },
    icon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_neutral_icon_50,
        disabled: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_accent_disabled_icon_100,
        },
    },
});
export const commonStylesSmall = (FOUNDATIONS) => ({
    ...commonStyles(FOUNDATIONS),
    container: {
        border_radius: FOUNDATIONS.radius_250,
        padding: FOUNDATIONS.spacing_150,
        background_color: FOUNDATIONS.color_comp_resources_iconhighlighted_bg,
        width: FOUNDATIONS.size_450,
        height: FOUNDATIONS.size_450,
        selected: {
            border_color: FOUNDATIONS.color_accent_selected_border_50,
        },
    },
    icon: {
        width: FOUNDATIONS.size_350,
        height: FOUNDATIONS.size_350,
        color: FOUNDATIONS.color_neutral_icon_50,
        disabled: {
            width: FOUNDATIONS.size_350,
            height: FOUNDATIONS.size_350,
            color: FOUNDATIONS.color_accent_disabled_icon_100,
        },
    },
});
export const commonStylesMedium = (FOUNDATIONS) => ({
    ...commonStyles(FOUNDATIONS),
    container: {
        border_radius: FOUNDATIONS.radius_250,
        padding: FOUNDATIONS.spacing_200,
        background_color: FOUNDATIONS.color_comp_resources_iconhighlighted_bg,
        width: FOUNDATIONS.size_500,
        height: FOUNDATIONS.size_500,
        selected: {
            border_color: FOUNDATIONS.color_accent_selected_border_50,
        },
    },
    icon: {
        width: FOUNDATIONS.size_350,
        height: FOUNDATIONS.size_350,
        color: FOUNDATIONS.color_neutral_icon_50,
        disabled: {
            width: FOUNDATIONS.size_350,
            height: FOUNDATIONS.size_350,
            color: FOUNDATIONS.color_accent_disabled_icon_100,
        },
    },
});
export const commonStylesLarge = (FOUNDATIONS) => ({
    ...commonStyles(FOUNDATIONS),
    container: {
        border_radius: FOUNDATIONS.radius_250,
        padding: FOUNDATIONS.spacing_250,
        background_color: FOUNDATIONS.color_comp_resources_iconhighlighted_bg,
        width: FOUNDATIONS.size_550,
        height: FOUNDATIONS.size_550,
        selected: {
            border_color: FOUNDATIONS.color_accent_selected_border_50,
        },
    },
    icon: {
        width: FOUNDATIONS.size_350,
        height: FOUNDATIONS.size_350,
        color: FOUNDATIONS.color_neutral_icon_50,
        disabled: {
            width: FOUNDATIONS.size_350,
            height: FOUNDATIONS.size_350,
            color: 'red',
        },
    },
});
//# sourceMappingURL=commonStyles.js.map